import { render, staticRenderFns } from "./SailProformaStatusPopup.vue?vue&type=template&id=5831eb88&scoped=true&"
import script from "./SailProformaStatusPopup.vue?vue&type=script&lang=js&"
export * from "./SailProformaStatusPopup.vue?vue&type=script&lang=js&"
import style0 from "./SailProformaStatusPopup.vue?vue&type=style&index=0&id=5831eb88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5831eb88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5831eb88')) {
      api.createRecord('5831eb88', component.options)
    } else {
      api.reload('5831eb88', component.options)
    }
    module.hot.accept("./SailProformaStatusPopup.vue?vue&type=template&id=5831eb88&scoped=true&", function () {
      api.rerender('5831eb88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/booking/SailProformaStatusPopup.vue"
export default component.exports